import {
  generatePath,
  Navigate,
  useLocation,
  useParams
} from 'react-router-dom';

interface LegacyRouteRedirectProps {
  to: string;
}

export const LegacyRouteRedirect = ({ to }: LegacyRouteRedirectProps) => {
  const params = useParams();
  const { search, hash } = useLocation();

  return (
    <Navigate
      to={{ pathname: generatePath(to, params), search, hash }}
      replace
    />
  );
};
